import { Link } from "react-router-dom";
import { FileText, Lock, Mail, Scale, Copyright, Globe } from 'lucide-react';
import styles from '../styles/pages/LegaleNotice.module.css';

const LegaleNotice = () => {
  const sectionStyle = {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '3rem 2rem'
  };

  const cardStyle = {
    background: '#fff',
    padding: '2rem',
    borderRadius: '0.7rem',
    marginBottom: '2rem',
    boxShadow: '0 4px 12px rgba(1, 31, 55, 0.08)',
    borderLeft: '0.2rem solid #011F37',
    borderRight: '0.2rem solid #011F37'
  };

  const titleStyle = {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#011F37',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  };

  const subtitleStyle = {
    fontSize: '1.3rem',
    fontWeight: '600',
    color: '#011F37',
    marginTop: '1.5rem',
    marginBottom: '1rem'
  };

  const textStyle = {
    fontSize: '1rem',
    color: '#676768',
    lineHeight: '1.8',
    marginBottom: '1rem'
  };

  const highlightStyle = {
    color: '#011F37',
    fontWeight: '600'
  };

  const dividerStyle = {
    width: 'clamp(40px, 12vw, 80px)',
    height: 'clamp(3px, 0.5vw, 4px)',
    background: 'linear-gradient(90deg, #011F37 0%, #676768 100%)',
    margin: '1rem 0 2rem 0',
  };

  return (
    <div style={{ background: '#f8f9fa', minHeight: '100vh' }}>
      {/* Header Section */}
      <section className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>
            Mentions légales
          </h1>
          <p className={styles.subtitle}>
            Informations légales et conditions d'utilisation du site
          </p>
        </div>
      </section>

        {/* Content Section */}
        <section style={sectionStyle}>
            {/* Éditeur du site */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <FileText size={24} style={{ flexShrink: 0 }}/>
                    Éditeur du site
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle} className="responsiveText">
                    Le site <span style={highlightStyle}>www.meca-gtech.fr</span> est édité par :
                </p>
                
                <div style={{ ...textStyle, background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginTop: '0.5rem' }}>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Raison sociale :</span> MECA-GTECH</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Forme juridique :</span> SARL</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Capital social :</span> 15 000€</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Siège social :</span> 1059, Rue Saint Antoine, 62370 Ruminghem - France</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>SIRET :</span> 938 901 626 00011</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>N° TVA Intracommunautaire :</span> FR 72 938 901 626</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Téléphone :</span> +33 3 28 62 80 01</p>
                    <p style={{ marginBottom: '0' }}><span style={highlightStyle}>Email :</span> contact@meca-gtech.fr</p>
                </div>

                <p style={{ ...textStyle, marginTop: '1.5rem' }}>
                    <span style={highlightStyle}>Directeurs de la publication :</span> Thomas et Julien Golliot
                </p>
            </div>

            {/* Hébergement */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <Globe size={24} style={{ flexShrink: 0 }}/>
                    Hébergement
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    Le site est hébergé par :
                </p>
                
                <div style={{ ...textStyle, background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginTop: '0.5rem' }}>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Raison sociale :</span> OVH SAS</p>
                    
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Site web :</span> <a href="https://www.ovhcloud.com/fr/" target="_blank" rel="noopener noreferrer">https://www.ovhcloud.com/fr/</a></p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Capital social :</span> 50 000 000 €</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Siège social :</span> 2, rue Kellermann, 59100 Roubaix - France</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>SIRET :</span> 424 761 419 00045</p>
                    <p style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>N° TVA Intracommunautaire :</span> FR 22 424 761 419</p>
                </div>
            </div>

            {/* Propriété intellectuelle */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <Copyright size={24} style={{ flexShrink: 0 }}/>
                    Propriété intellectuelle
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, etc.) est la propriété exclusive de <span style={highlightStyle}>MECA-GTECH</span> ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
                </p>
                
                <p style={textStyle}>
                    Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de MECA-GTECH.
                </p>
                
                <p style={textStyle}>
                    Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
                </p>
            </div>

            {/* Protection des données personnelles */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <Lock size={24} style={{ flexShrink: 0 }}/>
                    Protection des données personnelles (RGPD)
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                </p>

                <h3 style={subtitleStyle}>Collecte des données</h3>
                <p style={textStyle}>
                    Les données personnelles collectées sur ce site sont uniquement celles que vous nous transmettez volontairement via le formulaire de contact. Ces données incluent :
                </p>
                <div style={{ textAlign: 'center' }}>
                    <ul style={{ ...textStyle, paddingLeft: '2rem', textAlign: 'left', display: 'inline-block', margin: '0' }}>
                        <li style={{ marginBottom: '0.5rem' }}>Nom et prénom</li>
                        <li style={{ marginBottom: '0.5rem' }}>Adresse e-mail</li>
                        <li style={{ marginBottom: '0.5rem' }}>Numéro de téléphone (optionnel)</li>
                        <li style={{ marginBottom: '0.5rem' }}>Message</li>
                    </ul>
                </div>

                <h3 style={subtitleStyle}>Utilisation des données</h3>
                <p style={textStyle}>
                    Vos données sont utilisées exclusivement pour :
                </p>
                <div style={{ textAlign: 'center' }}>
                    <ul style={{ ...textStyle, paddingLeft: '2rem', textAlign: 'left', display: 'inline-block', margin: '0' }}>
                        <li style={{ marginBottom: '0.5rem' }}>Répondre à vos demandes de contact</li>
                        <li style={{ marginBottom: '0.5rem' }}>Vous fournir des informations sur nos services</li>
                        <li style={{ marginBottom: '0.5rem' }}>Améliorer la qualité de nos prestations</li>
                    </ul>
                </div>

                <h3 style={subtitleStyle}>Conservation des données</h3>
                <p style={textStyle}>
                    Vos données personnelles sont conservées pendant une durée maximale de <span style={highlightStyle}>3 ans</span> à compter de notre dernier contact.
                </p>

                <h3 style={subtitleStyle}>Vos droits</h3>
                <p style={textStyle}>
                    Pour exercer vos droits ou pour toute question relative au traitement de vos données, vous pouvez nous contacter à l'adresse : <span style={highlightStyle}>contact@meca-gtech.fr</span>
                </p>
            </div>

            {/* Statistiques de visite - Plausible */}
            {/* <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={titleStyle}>
                    <Cookie size={24} style={{ flexShrink: 0 }}/>
                    Statistiques de visite
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    Ce site utilise <span style={highlightStyle}>Plausible Analytics</span>, un outil de mesure d'audience respectueux de la vie privée.
                </p>

                <h3 style={subtitleStyle}>Pourquoi Plausible ?</h3>
                <ul style={{ ...textStyle, paddingLeft: '2rem' }}>
                    <li style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Aucun cookie :</span> Plausible ne stocke aucun cookie sur votre appareil</li>
                    <li style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>100% anonyme :</span> Aucune donnée personnelle n'est collectée</li>
                    <li style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Conforme RGPD :</span> Pas besoin de consentement préalable</li>
                    <li style={{ marginBottom: '0.5rem' }}><span style={highlightStyle}>Open source :</span> Code source public et auditable</li>
                </ul>

                <h3 style={subtitleStyle}>Données collectées</h3>
                <p style={textStyle}>
                    Plausible collecte uniquement des statistiques agrégées et anonymes :
                </p>
                <ul style={{ ...textStyle, paddingLeft: '2rem' }}>
                    <li style={{ marginBottom: '0.5rem' }}>Nombre de visiteurs</li>
                    <li style={{ marginBottom: '0.5rem' }}>Pages consultées</li>
                    <li style={{ marginBottom: '0.5rem' }}>Pays d'origine (sans stockage de l'adresse IP)</li>
                    <li style={{ marginBottom: '0.5rem' }}>Type d'appareil (desktop, mobile, tablette)</li>
                </ul>

                <p style={textStyle}>
                    <span style={highlightStyle}>Aucune donnée personnelle</span> (nom, email, adresse IP, etc.) n'est collectée ou stockée.
                </p>

                <p style={textStyle}>
                    Pour en savoir plus sur Plausible et sa politique de confidentialité : 
                    <a 
                        href="https://plausible.io/privacy" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: '#011F37', textDecoration: 'underline', marginLeft: '4px' }}
                    >
                        https://plausible.io/privacy
                    </a>
                </p>
            </div> */}

            {/* Responsabilité */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <Scale size={24} style={{ flexShrink: 0 }}/>
                    Limitation de responsabilité
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    MECA-GTECH s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site, dont elle se réserve le droit de corriger le contenu à tout moment et sans préavis.
                </p>
                
                <p style={textStyle}>
                    Toutefois, MECA-GTECH ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
                </p>
                
                <p style={textStyle}>
                    En conséquence, MECA-GTECH décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.
                </p>

                <h3 style={subtitleStyle}>Liens hypertextes</h3>
                <p style={textStyle}>
                    Le site peut contenir des liens vers d'autres sites internet. MECA-GTECH n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
            </div>

            {/* Droit applicable */}
            <div style={cardStyle} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{...titleStyle, textAlign: 'left'}}>
                    <Globe size={24} style={{ flexShrink: 0 }}/>
                    Droit applicable et juridiction
                </h2>
                <div style={dividerStyle}></div>
                
                <p style={textStyle}>
                    Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.
                </p>
            </div>

            {/* Contact */}
            <div style={{
                ...cardStyle,
                background: 'linear-gradient(135deg, #011F37 0%, #013a5f 100%)',
                color: '#fff',
                textAlign: 'center'
            }} className={`${styles.responsiveCard} responsiveCard`}>
                <h2 style={{ ...titleStyle, color: '#fff', justifyContent: 'center' }}>
                    <span style={{ fontSize: '1.5rem' }}><Mail size={24} style={{ flexShrink: 0 }}/></span>
                    Une question ?
                </h2>
                <p style={{ ...textStyle, color: 'rgba(255, 255, 255, 0.9)', fontSize: '1.1rem' }}>
                    Pour toute question concernant ces mentions légales, n'hésitez pas à nous contacter
                </p>
                <Link to="/contact" 
                    style={{
                        display: 'inline-block',
                        marginTop: '1rem',
                        padding: '12px 30px',
                        background: '#fff',
                        color: '#011F37',
                        textDecoration: 'none',
                        borderRadius: '8px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                >
                    Nous contacter
                </Link>
            </div>

            {/* Dernière mise à jour */}
            <p style={{
                textAlign: 'center',
                color: '#676768',
                fontSize: '0.9rem',
                marginTop: '3rem',
                fontStyle: 'italic'
            }}>
                Dernière mise à jour : 22 décembre 2025
            </p>
        </section>
    </div>
  );
};

export default LegaleNotice;
